import api from './axios';

const params = (idEmpresa) => (idEmpresa ? { id_empresa: idEmpresa } : undefined);

export const listQualidades = (incluirInativos) =>
  api.get('/qualidades/', { params: incluirInativos ? { incluir_inativos: true } : undefined });
export const createQualidade = (data, idEmpresa) => api.post('/qualidades/', data, { params: params(idEmpresa) });
export const updateQualidade = (id, data, idEmpresa) =>
  api.patch(`/qualidades/${id}`, data, { params: params(idEmpresa) });
